export default __webpack_public_path__ + "static/media/illustration-web-development.72213d36.svg";